import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck, LogIn, LogOut } from "lucide-react";

export const Header = ({ title = "Urban Den", subtitle, right }) => {
  const { isAdmin, logout } = useAuth();
  const { pathname } = useLocation();

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAF6EF]/85 border-b border-brand-200/60"
      data-testid="app-header"
    >
      <div className="max-w-md mx-auto px-5 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2.5" data-testid="header-home-link">
          <div className="w-10 h-10 rounded-2xl bg-brand-700 flex items-center justify-center shadow-sm">
            <span className="font-heading text-white text-xl font-semibold tracking-tight">U</span>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-semibold text-brand-900 tracking-tight">
              {title}
            </span>
            <span className="text-[11px] text-brand-700/70 tracking-wide">
              {subtitle || "Fabric Inventory"}
            </span>
          </div>
        </Link>
        <div className="flex items-center gap-2">
          {right}
          {isAdmin ? (
            <button
              onClick={logout}
              className="h-10 px-3 rounded-full flex items-center gap-1.5 bg-brand-100 hover:bg-brand-200 text-brand-700 text-xs font-medium transition-colors"
              data-testid="header-logout-btn"
              title="Log out"
            >
              <LogOut className="w-3.5 h-3.5" strokeWidth={2} />
              <span>Logout</span>
            </button>
          ) : (
            <Link
              to={pathname.startsWith("/admin") ? "/admin/login" : "/admin/login"}
              className="h-10 px-3 rounded-full flex items-center gap-1.5 bg-brand-100 hover:bg-brand-200 text-brand-700 text-xs font-medium transition-colors"
              data-testid="header-admin-login-link"
              title="Admin login"
            >
              <ShieldCheck className="w-3.5 h-3.5" strokeWidth={2} />
              <span>Admin</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
